module.exports = __webpack_public_path__ + "static/XDefi-2a2df17199431ea74ed6177d885cfe50.png";